import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FIELD_LIMITS } from "../../../utils/fieldLimits";

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .max(FIELD_LIMITS.FULL_NAME, `Name cannot exceed ${FIELD_LIMITS.FULL_NAME} characters`),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .matches(/^[0-9\-\+\s\(\)]{7,20}$/, "Invalid phone number")
    .required("Phone is required"),
  employeenumber: Yup.string()
    .max(FIELD_LIMITS.EMPLOYEE_NUMBER, `Employee Number cannot exceed ${FIELD_LIMITS.EMPLOYEE_NUMBER} characters`),
});

const EditProfileForm = ({ initialValues, onSubmit, title, countries, type }) => (
  <div className="card">
    <div className="card-header">
      <h4 className="card-title">{title || "Edit Profile"}</h4>
    </div>
    <div className="card-body">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <section>
              <div className="row">
                {/* Name */}
                <div className="col-lg-6 mb-2">
                  <div className="form-group mb-3">
                    <label className="text-label">Name*</label>
                    <Field name="name" className="form-control" placeholder="Enter your name..." maxLength={FIELD_LIMITS.FULL_NAME} />
                    <div className="text-danger" style={{ fontSize: 13 }}>
                      <ErrorMessage name="name" />
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="col-lg-6 mb-2">
                  <div className="form-group mb-3">
                    <label className="text-label">Email*</label>
                    <Field name="email" type="email" className="form-control" placeholder="example@example.com" disabled/>
                    <div className="text-danger" style={{ fontSize: 13 }}>
                      <ErrorMessage name="email" />
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="col-lg-6 mb-2">
                  <div className="form-group mb-3">
                    <label className="text-label">Phone*</label>
                    <Field name="phone" className="form-control" placeholder="212-999-0000" />
                    <div className="text-danger" style={{ fontSize: 13 }}>
                      <ErrorMessage name="phone" />
                    </div>
                  </div>
                </div>
                {type === 'corporate' && (
                <>
                {/* Country */}
                <div className="col-lg-6 mb-2">
                  <div className="form-group mb-3">
                    <label className="text-label">Country*</label>
                    <Field as="select" name="country" className="form-control">
                      <option value="">-- Select a country --</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.name}>
                          {country.name} ({country.code})
                        </option>
                      ))}
                    </Field>
                    <div className="text-danger" style={{ fontSize: 13 }}>
                      <ErrorMessage name="country" />
                    </div>
                  </div>
                </div>
                </>
                )}
                {/* Conditionally render CorporateName and UserType */}
                {type === 'user' && (
                  <>
                    <div className="col-lg-6 mb-2">
                      <div className="form-group mb-3">
                        <label className="text-label">Employee Number</label>
                        <Field name="employeenumber" className="form-control" placeholder="Employee Number" maxLength={FIELD_LIMITS.EMPLOYEE_NUMBER} />
                        <div className="text-danger" style={{ fontSize: 13 }}>
                          <ErrorMessage name="employeenumber" />
                        </div>
                      </div>
                    </div>

      
                  </>
                )}
              </div>

              <div className="text-center toolbar toolbar-bottom p-2">
                <button type="submit" className="btn btn-primary sw-btn-next" disabled={isSubmitting}>
                  {isSubmitting ? "Saving..." : "Save"}
                </button>
              </div>
            </section>
          </Form>
        )}
      </Formik>
    </div>
  </div>
);

export default EditProfileForm; 